'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var PropTypes = _interopDefault(require('prop-types'));

var react = require('react');

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var useBeforeunload = function useBeforeunload() {
  var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
    throw new TypeError("Expected \"handler\" to be a function, not ".concat(_typeof(handler), "."));
  }

  var handlerRef = react.useRef(handler);
  react.useEffect(function () {
    handlerRef.current = handler;
  }, [handler]);
  react.useEffect(function () {
    var handleBeforeunload = function handleBeforeunload(event) {
      var returnValue;

      if (typeof handlerRef.current === 'function') {
        returnValue = handlerRef.current(event);
      }

      if (event.defaultPrevented) {
        event.returnValue = '';
      }

      if (typeof returnValue === 'string') {
        event.returnValue = returnValue;
        return returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeunload);
    return function () {
      window.removeEventListener('beforeunload', handleBeforeunload);
    };
  }, []);
};

var Beforeunload = function Beforeunload(props) {
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      onBeforeunload = props.onBeforeunload;
  useBeforeunload(onBeforeunload);
  return children;
};

Beforeunload.propTypes = {
  children: PropTypes.any,
  onBeforeunload: PropTypes.func.isRequired
};
exports.Beforeunload = Beforeunload;
exports.useBeforeunload = useBeforeunload;